import { Avatar, Menu } from 'grommet';
import { User } from 'grommet-icons';

const Profile = ({ setLoggedIn, setView, user }) => {
    return (
        <Menu
            icon={user.profilePicture ? <Avatar src={user.profilePicture}/> : <Avatar><User/></Avatar>}
            items={[
                {
                    label:'Sign Out',
                    onClick: () => {
                        console.log('sign user out')
                        setView('signIn')
                        setLoggedIn(false);
                    }
                }
            ]}
        />
    );
}

export default Profile;